import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import i18n from 'i18next';
import getBaseTheme from 'styles/getBaseTheme';
import config from 'utils/config';
import api from 'utils/api';
import { fetchMindsetSettings } from 'actions/userProfile/useFetchMindsetAgent';
import createElement from 'tricks/dom/createElement';
import loadScript from 'tricks/browser/http/loadScript';
import { typeScale } from 'styles/globals';
import { getDarkerColorShadeHex, remToPx } from './ui';

// ID of the container where the Mindset SDK will be rendered
export var MINDSET_ID = 'mindset-container';
var MINDSET_SDK2_URL = "https://mindset-prod2-eu-embedded-sdk.web.app/mindset-sdk2.js";
function getAuthToken() {
  return _getAuthToken.apply(this, arguments);
}
function _getAuthToken() {
  _getAuthToken = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var _yield$api, authToken;
    return _regeneratorRuntime.wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 1;
          return api('get', '/api/mindset/authToken');
        case 1:
          _yield$api = _context.sent;
          authToken = _yield$api.authToken;
          return _context.abrupt("return", authToken);
        case 2:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _getAuthToken.apply(this, arguments);
}
function domPrefetchScript(scriptURL) {
  // Prefetch the scriptURL for future navigation, if it hasn't been prefetched yet
  var prefetchedScript = document.querySelector("link[rel=prefetch][href=\"".concat(scriptURL, "\"]"));
  if (!prefetchedScript) {
    var newLink = createElement('link', {
      rel: 'prefetch',
      href: scriptURL,
      as: 'script'
    });
    document.head.appendChild(newLink);
  }
}
function renderMindsetSDK2(_x) {
  return _renderMindsetSDK.apply(this, arguments);
}
function _renderMindsetSDK() {
  _renderMindsetSDK = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref) {
    var _parentEl$querySelect;
    var scriptURL, appUid, initialQuestion, agentUid, existingMindsetScript, parentEl, theme, cardTheme, mindsetCustomEl, errorColor, primaryButtonColor, defaultButtonColor, importantButtonColor, mindsetPrimaryText, mindsetPrimaryRawBg, mindsetPrimaryBg, cardBgDarker, mindsetTheme, initData;
    return _regeneratorRuntime.wrap(function (_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          scriptURL = _ref.scriptURL, appUid = _ref.appUid, initialQuestion = _ref.initialQuestion, agentUid = _ref.agentUid;
          existingMindsetScript = document.querySelector("script[src=\"".concat(scriptURL, "\"]"));
          if (existingMindsetScript) {
            delete window.mindset; // Clear any previous mindset instance
            delete window._mindset_; // Clear any previous mindset instance

            // Remove from the DOM
            // This is merely symbolic, as it does not change runtime of existing scripts
            existingMindsetScript.remove();
          }
          parentEl = document.getElementById(MINDSET_ID); // Remove any existing mindset agent element to avoid duplicates
          parentEl === null || parentEl === void 0 || (_parentEl$querySelect = parentEl.querySelector('mindset-agent')) === null || _parentEl$querySelect === void 0 || _parentEl$querySelect.remove();
          theme = getBaseTheme();
          cardTheme = theme.sections.card;
          mindsetCustomEl = createElement('mindset-agent', _objectSpread({
            agentUid: agentUid,
            style: "width: 100%; height: 70vh; display: block; background-color: ".concat(cardTheme.background, ";"),
            loadingText: i18n.t('loading')
          }, initialQuestion && {
            initialQuestion: initialQuestion
          }));
          parentEl === null || parentEl === void 0 || parentEl.appendChild(mindsetCustomEl);

          /** **************************
           * MINDSET SDK INITIALIZATION
           ** **************************/

          // Load the Mindset SDK script
          // HACK: We have to load this in every time our application changes the initialQuestion 🤯
          _context2.next = 1;
          return loadScript(MINDSET_SDK2_URL);
        case 1:
          // Theming
          errorColor = theme.globals.colorBlocks.negative;
          primaryButtonColor = theme.globals.buttons.primary;
          defaultButtonColor = theme.globals.buttons.default;
          importantButtonColor = theme.globals.buttons.important;
          mindsetPrimaryText = theme.globals.colorBlocks.mindset;
          mindsetPrimaryRawBg = theme.globals.colorBlocks['mindset-background'];
          mindsetPrimaryBg = mindsetPrimaryRawBg === cardTheme.background ? getDarkerColorShadeHex(mindsetPrimaryRawBg) : mindsetPrimaryRawBg;
          cardBgDarker = getDarkerColorShadeHex(cardTheme.background);
          mindsetTheme = {
            brightness: 'light',
            surfaceTint: null,
            primary: mindsetPrimaryText,
            onPrimary: mindsetPrimaryBg,
            primaryContainer: mindsetPrimaryBg,
            onPrimaryContainer: mindsetPrimaryText,
            secondary: defaultButtonColor.text,
            onSecondary: defaultButtonColor.background,
            secondaryContainer: defaultButtonColor.text,
            onSecondaryContainer: defaultButtonColor.background,
            tertiary: importantButtonColor.text,
            onTertiary: importantButtonColor.background,
            tertiaryContainer: importantButtonColor.text,
            onTertiaryContainer: importantButtonColor.background,
            error: errorColor,
            onError: cardTheme.text,
            errorContainer: cardTheme.text,
            onErrorContainer: errorColor,
            background: cardTheme.background,
            onBackground: cardTheme.text,
            surface: cardTheme.background,
            onSurface: cardTheme.text,
            surfaceVariant: cardTheme.background,
            onSurfaceVariant: cardTheme.text,
            outline: cardTheme.text,
            outlineVariant: cardTheme.text,
            shadow: cardTheme.shade,
            scrim: '#000000',
            inverseSurface: cardTheme.text,
            inverseOnSurface: cardTheme.background,
            inversePrimary: primaryButtonColor.text,
            primaryFixed: primaryButtonColor.background,
            onPrimaryFixed: primaryButtonColor.text,
            primaryFixedDim: getDarkerColorShadeHex(primaryButtonColor.background),
            onPrimaryFixedVariant: primaryButtonColor.text,
            secondaryFixed: defaultButtonColor.background,
            onSecondaryFixed: defaultButtonColor.text,
            secondaryFixedDim: getDarkerColorShadeHex(defaultButtonColor.background),
            onSecondaryFixedVariant: defaultButtonColor.text,
            tertiaryFixed: importantButtonColor.background,
            onTertiaryFixed: importantButtonColor.text,
            tertiaryFixedDim: getDarkerColorShadeHex(importantButtonColor.background),
            onTertiaryFixedVariant: importantButtonColor.text,
            surfaceDim: cardBgDarker,
            surfaceBright: getDarkerColorShadeHex(cardTheme.background, 0.01),
            surfaceContainerLowest: cardBgDarker,
            surfaceContainerLow: cardBgDarker,
            surfaceContainer: cardBgDarker,
            surfaceContainerHigh: cardBgDarker,
            surfaceContainerHighest: cardBgDarker
          };
          initData = {
            fetchAuthentication: getAuthToken,
            appUid: appUid,
            theme: mindsetTheme,
            customFontTheme: {
              fontFamily: 'Open Sans',
              textStyles: {
                titleLarge: {
                  fontWeight: 600,
                  fontSize: remToPx(typeScale.l)
                },
                titleMedium: {
                  fontWeight: 600,
                  fontSize: remToPx(typeScale.m)
                },
                titleSmall: {
                  fontWeight: 600,
                  fontSize: remToPx(typeScale.m)
                },
                bodyLarge: {
                  fontWeight: 400,
                  fontSize: remToPx(typeScale.m)
                },
                bodyMedium: {
                  fontWeight: 400,
                  fontSize: remToPx(typeScale.s)
                },
                bodySmall: {
                  fontWeight: 400,
                  fontSize: remToPx(typeScale.s)
                }
              }
            }
          };
          if (config.mindsetAgentVoice) {
            initData.enableVoice = 'true';
          }

          // Reinitialize instead of re-injecting script e.g. when the initial question changes
          _context2.next = 2;
          return window.mindset.init(initData);
        case 2:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _renderMindsetSDK.apply(this, arguments);
}
function renderMindsetSDK(_x2) {
  return _renderMindsetSDK2.apply(this, arguments);
}
function _renderMindsetSDK2() {
  _renderMindsetSDK2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_ref2) {
    var scriptURL, appUid, initialQuestion, agentUid, _yield$Promise$all, _yield$Promise$all2, authToken;
    return _regeneratorRuntime.wrap(function (_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          scriptURL = _ref2.scriptURL, appUid = _ref2.appUid, initialQuestion = _ref2.initialQuestion, agentUid = _ref2.agentUid;
          _context3.next = 1;
          return Promise.all([
          // Get the authentication token
          getAuthToken(),
          // Load the Mindset SDK script if it's not already been loaded
          window.mindset || loadScript(scriptURL)]);
        case 1:
          _yield$Promise$all = _context3.sent;
          _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 1);
          authToken = _yield$Promise$all2[0];
          window.mindset.initApp({
            containerId: MINDSET_ID,
            appUid: appUid,
            authToken: authToken,
            loadingText: i18n.t('loading')
          });

          // Initiate the Mindset SDK
          window.mindset.startAgentThread({
            /* 
            agentUid
            - Required
            */
            agentUid: agentUid,
            /* 
            initialQuestion
            - optional
            - If this is missing or an empty string then the configured icebreaker message, if any, will be used to start an agent conversation.
            - If this is supplied then it will be sent to the agent as the first input from the user. */
            initialQuestion: initialQuestion
            /*
            variables
            - optional
            - e.g. { role: 'supervisor', customerId: 'bigcorp' }
            - Some content can be ingested so that it will link to external URLs. It is possible that these URLs will contain placeholders that need to be replaced with specific values for individual users.
            -This parameter allows you to specify those values at the moment the user interacts with the agent.
            */
            // variables: { role: 'supervisor', customerId: 'bigcorp' },
          });
        case 2:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return _renderMindsetSDK2.apply(this, arguments);
}
export function addMindsetAIIfRequired() {
  return _addMindsetAIIfRequired.apply(this, arguments);
}
function _addMindsetAIIfRequired() {
  _addMindsetAIIfRequired = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
    var _ref3,
      _ref3$render,
      render,
      _ref3$search,
      initialQuestion,
      appUid,
      mindsetSDKv2,
      _yield$fetchMindsetSe,
      agentUid,
      scriptURL,
      _args4 = arguments;
    return _regeneratorRuntime.wrap(function (_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          _ref3 = _args4.length > 0 && _args4[0] !== undefined ? _args4[0] : {}, _ref3$render = _ref3.render, render = _ref3$render === void 0 ? false : _ref3$render, _ref3$search = _ref3.search, initialQuestion = _ref3$search === void 0 ? '' : _ref3$search;
          appUid = config.mindsetAppUid, mindsetSDKv2 = config.mindsetSDKv2;
          if (appUid) {
            _context4.next = 1;
            break;
          }
          return _context4.abrupt("return");
        case 1:
          _context4.next = 2;
          return fetchMindsetSettings();
        case 2:
          _yield$fetchMindsetSe = _context4.sent;
          agentUid = _yield$fetchMindsetSe.agentUid;
          if (agentUid) {
            _context4.next = 3;
            break;
          }
          return _context4.abrupt("return");
        case 3:
          scriptURL = mindsetSDKv2 ? MINDSET_SDK2_URL : "https://".concat(appUid, ".mindset.ai/mindset-sdk.js");
          if (render) {
            _context4.next = 4;
            break;
          }
          domPrefetchScript(scriptURL);
          return _context4.abrupt("return");
        case 4:
          if (!mindsetSDKv2) {
            _context4.next = 6;
            break;
          }
          _context4.next = 5;
          return renderMindsetSDK2({
            scriptURL: scriptURL,
            appUid: appUid,
            initialQuestion: initialQuestion,
            agentUid: agentUid
          });
        case 5:
          _context4.next = 7;
          break;
        case 6:
          _context4.next = 7;
          return renderMindsetSDK({
            scriptURL: scriptURL,
            appUid: appUid,
            initialQuestion: initialQuestion,
            agentUid: agentUid
          });
        case 7:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
  return _addMindsetAIIfRequired.apply(this, arguments);
}